class ClerkSearchPage extends HTMLElement {
    constructor() {
        super();

        this.productCounts = this.querySelectorAll('[data-product-count]');
        this.loadMoreButton = this.querySelector('[data-clerk-load-more]');
        this.grid = this.querySelector('[data-clerk-grid]');
        this.emptyState = this.querySelector('[data-clerk-empty-state]');

        this.currentPage = 1;
        this.pages = 0;
        this.limit = 20;
        this.sortBy = 'default';

        this.dirty = false;

        this.facets = {};
        this.inputNames = {};
        this.filter = '';

        this.search();
        this.addEventListeners()
        this.addFacetEventlisteners();
    }

    addEventListeners() {
        this.loadMoreButton.addEventListener('click', this.search.bind(this))
    }

    cachedFetch(url, type = 'json') {
        return new Promise(async (resolve) => {
            if (sessionStorage.getItem(`clerk-search-${url}`)) {
                resolve(type === 'json' ? JSON.parse(sessionStorage.getItem(`clerk-search-${url}`)) : sessionStorage.getItem(`clerk-search-${url}`));
            } else {
                const response = await fetch(url).then(r => {
                    if (type === 'json') {
                        return r.json();
                    } else {
                        return r.text()
                    }
                });

                if (type === "text") {
                    if (!response.includes('<head')) sessionStorage.setItem(`clerk-search-${url}`, response);
                } else sessionStorage.setItem(`clerk-search-${url}`, type === 'json' ? JSON.stringify(response.results.products) : response);
                resolve(type === 'json' ? response.results.products : response)
            }
        })
    }

    async search() {
        if (this.dirty) return;

        const params = new URLSearchParams(window.location.search);

        const queryObj = {
            visitor: this.visitor,
            key: window.integrations.clerk.key,
            query: params.get('q'),
            labels: ["Search Page"],
            no_design: true,
            searches: {
                products: {
                    facets: ["variant_option_size", "colour_filter_app_", "collection", "material_filter_", "price"],
                    index: "products",
                    attributes: ["handle"],
                    limit: this.limit * this.currentPage
                }
            }
        }

        if (this.sortBy !== 'default') {
            queryObj.searches.products.sort = this.sortBy;
        }

        if (this.filter) {
            queryObj.searches.products.filter = this.filter;
        }

        const response = await this.cachedFetch(`//api.clerk.io/v3/search/omni?payload=${JSON.stringify(queryObj)}`);

        this.pages = Math.ceil(response.estimated_total_count / this.limit);

        if (response?.facets_stats?.price && response.facets['price']) {
            response.facets['price'] = response.facets_stats.price
        }

        if (!this.filter) {
            this.facets = response.facets;
        }

        if (this.loadMoreButton) {
            this.loadMoreButton.hidden = response.result.length === 0 || this.currentPage === this.pages
        }

        if (response.result.length > 0) {
            this.productCounts.forEach(elem => {
                elem.hidden = false;
                elem.innerHTML = elem.dataset.content.replace('PRODUCT_COUNT', response.estimated_total_count)
            });

            const productResponses = await Promise.all(response.result.map((product) => this.cachedFetch(`${Shopify.routes.root}products/${product.handle}?view=clerk-item`, 'text')));
            this.emptyState.hidden = true;
            this.grid.hidden = false;
            this.grid.innerHTML = productResponses.filter(i => !i.includes('<head')).map((productItem) => productItem).join('')

            this.currentPage = this.currentPage + 1;
            this.renderFacets();
            Clerk("click", "*[data-clerk-product-id]");
        } else {
            this.grid.hidden = true;
            this.emptyState.hidden = false;
        }

        this.dirty = false;
    }

    get visitor() {
        return window.sessionStorage.getItem('visitor_id') || 'auto';
    }

    processTemplateVariables(template, type) {
        const facetForType = this.facets[type];
        const wrapper = document.createElement('div');

        wrapper.classList.add('v-stack');

        if (facetForType) {
            if (type === "price") {
                const {max, min} = facetForType;

                const templateClone = template.cloneNode(true);
                const rangeSlider = templateClone.querySelector('.range-group');
                const rangeSliderMin = rangeSlider.firstElementChild;
                const rangeSliderMax = rangeSlider.lastElementChild;
                const priceFromField = templateClone.querySelector('input[name="filter.v.price.gte"]');
                const priceToField = templateClone.querySelector('input[name="filter.v.price.lte"]');

                const stepBy = Math.max(Math.ceil((max - min) / 100), 1);

                rangeSliderMin.setAttribute('step', stepBy.toString());
                rangeSliderMax.setAttribute('step', stepBy.toString());
                priceFromField.setAttribute('step', stepBy.toString());
                priceToField.setAttribute('step', stepBy.toString());

                rangeSliderMin.setAttribute('max', max);
                rangeSliderMax.setAttribute('max', max);
                priceFromField.setAttribute('max', max);
                priceToField.setAttribute('max', max);

                priceToField.setAttribute('placeholder', max);

                rangeSliderMax.setAttribute('value', max);

                if (this.inputNames['filter.v.price.gte']) {
                    rangeSliderMin.value = this.inputNames['filter.v.price.gte'];
                    priceFromField.value = this.inputNames['filter.v.price.gte'];
                }

                if (this.inputNames['filter.v.price.lte']) {
                    rangeSliderMax.value = this.inputNames['filter.v.price.lte'];
                    priceToField.value = this.inputNames['filter.v.price.lte'];
                }

                wrapper.appendChild(templateClone);
            } else {
                facetForType.forEach(facetValue => {
                    const templateClone = template.cloneNode(true);
                    const label = templateClone.querySelector('label');
                    const input = templateClone.querySelector('input');

                    label.textContent = facetValue.v;
                    label.setAttribute('for', label.getAttribute('for').replace('NAME-value', `${type}-${encodeURI(facetValue.v)}`).replace('---value', `${type}-${encodeURI(facetValue.v)}`));
                    input.setAttribute('name', type);
                    input.setAttribute('id', input.id.replace('NAME-value', `${type}-${encodeURI(facetValue.v)}`).replace('---value', `${type}-${encodeURI(facetValue.v)}`));
                    input.setAttribute('value', facetValue.v);

                    wrapper.appendChild(templateClone);
                })
            }
        }

        return wrapper;
    }

    renderFacets () {
        const facetDrawer = document.querySelector('#clerk-facets-drawer');
        const defaultTemplate = facetDrawer.querySelector('template[data-template="default"]');

        if (facetDrawer) {
            const colorFilterWrapper = facetDrawer.querySelector('[data-filter="colour_filter_app_"]');
            const filterWrappers = facetDrawer.querySelectorAll('[data-filter]');

            filterWrappers.forEach((filter) => {
                const filterType = filter.dataset.filter;
                const accordionContent = filter.querySelector('.accordion__content')
                const template = facetDrawer.querySelector(`template[data-template="${filterType}"]`);
                let content

                accordionContent.innerHTML = '';

                if (template) {
                    content = template.content.cloneNode(true);

                    if (filterType === 'variant_option_size' || filterType === 'price') {
                        content = this.processTemplateVariables(template.content.cloneNode(true), filterType);
                    }
                } else {
                    const defaultContent = defaultTemplate.content.cloneNode(true);
                    content = this.processTemplateVariables(defaultContent, filterType);
                }

               if (this.inputNames[filterType]) {
                   this.inputNames[filterType].forEach((value) => {
                       content.querySelector(filterType === 'colour_filter_app_' ? `input[name="${filterType}"][data-sys-id="${value}"]` : `input[name="${filterType}"][value="${value}"]`).checked = true;
                   });
               }

                accordionContent.appendChild(content);
            });

            if (colorFilterWrapper) {
                const colorFacet = this.facets['colour_filter_app_'];
                const colorFilterValues = colorFilterWrapper.querySelectorAll('input');

                colorFilterValues.forEach((input) => {
                    const facet = colorFacet.find(f => f.v === `gid://shopify/Metaobject/${input.dataset.sysId}`)

                    input.parentElement.hidden = !facet || facet.c === 0
                })

            }
        }
    }

    addFacetEventlisteners () {
        const node = document.querySelector('#clerk-facets-drawer');
        const sortByInputs = document.querySelectorAll('input[name="sort_by"]');

        node.addEventListener('dialog:after-hide', () => {
            const inputs = node.querySelectorAll('input');
            let filters = [];
            this.inputNames = {};

            const priceMinInput = node.querySelector('#clerk-facet-price-min');
            const priceMaxInput = node.querySelector('#clerk-facet-price-max');
            const checkedInputs = Array.from(inputs).filter(input => input.checked);

            checkedInputs.forEach(input => {
                if (!this.inputNames[input.getAttribute('name')])  {
                    this.inputNames[input.getAttribute('name')] = [];
                }
                this.inputNames[input.getAttribute('name')].push(input.getAttribute('name') === "colour_filter_app_" ? input.dataset.sysId : input.value);
            });

            Object.keys(this.inputNames).forEach(key => {
                if (key === "sort_by") return;

                const valuesForName = this.inputNames[key];
                let prefix = '';
                let filterTemplate;

                if (['material_filter_', 'colour_filter_app_'].includes(key)) {
                    prefix = 'gid://shopify/Metaobject/';
                    filterTemplate = `(${valuesForName.map(i => `${key} in ['${prefix}${i}']`).join(' OR ')})`
                } else {
                    filterTemplate = `(${key} in [${valuesForName.map(i => `'${prefix}${i}'`).join(',')}])`
                }

                filters.push(filterTemplate)
            })

            if (+(priceMinInput.value || 0) > 0 || +(priceMaxInput.value || +priceMaxInput.getAttribute('max')) < +priceMaxInput.getAttribute('max')) {
                const min = priceMinInput.value || priceMinInput.getAttribute('min');
                const max = priceMaxInput.value || priceMaxInput.getAttribute('max');

                this.inputNames['filter.v.price.gte'] = min;
                this.inputNames['filter.v.price.lte'] = max;
                filters.push(`(price >= ${min} and price <= ${max})`);
            }

            if (filters.join(' AND ') !== this.filter) {
                this.filter = filters.join(' AND ')
                this.search();
            }
        });

        sortByInputs.forEach(input => {
            input.addEventListener('change', () => {
                if (this.sortBy !== input.value) {
                    this.sortBy = input.value;
                    this.search()
                }
            });
        });
    }
}

if (!window.customElements.get("clerk-search-page")) {
    window.customElements.define("clerk-search-page", ClerkSearchPage);
}